import CoffeeClub from "./CoffeeClub";
import VeganShake from "./VeganShake";
import PopupEmail from "./PopupEmail";

export default [
    CoffeeClub,
    PopupEmail
    // VeganShake
]